import AxiosService from '@/api/ApiBase';
import {
  ChargeCode,
  ChargePartyUpdatePayload,
  ChargeRatesManagement,
  ChargeResponse,
  ManifestChargesFilters,
} from '@/types/charge/charge.types';
import { ChargeServiceEGuaranteePayload } from '@/types/charge/charge.service.types';
import { FilteredItemsResponse, FilterOptionsParams } from '@/types/service/filters.service';
import { ChargeEntity } from '@/types/charge/charge.entity';

const CHARGE_BASE_URL = 'warehouse/manifest/charges';

class ChargeService {
  createManualCharge(payload: any) {
    return AxiosService.post(`${CHARGE_BASE_URL}/create`, payload);
  }

  updateManualCharge(payload: any) {
    return AxiosService.put(`${CHARGE_BASE_URL}/update`, payload);
  }

  deleteManualCharge(id: any) {
    return AxiosService.delete(`${CHARGE_BASE_URL}/mannual/delete/${id}`);
  }

  uploadManifestCharge(payload: any) {
    return AxiosService.post(`${CHARGE_BASE_URL}/upload`, payload);
  }

  getManifestCharge() {
    return AxiosService.get<ChargeRatesManagement>(`${CHARGE_BASE_URL}/details`);
  }

  getManifestCharges(filters: ManifestChargesFilters) {
    return AxiosService.get<FilteredItemsResponse<Partial<ChargeEntity>>>(
      `warehouse/charges/filter`,
      { params: filters }
    );
  }

  getManifestChargesFilterOptions<T>(params: Omit<FilterOptionsParams, 'limit'>) {
    return AxiosService.get<T>(`warehouse/charges/filter/options`, {
      params: { ...params, limit: 100 },
    });
  }

  changeParty(payload: ChargePartyUpdatePayload) {
    return AxiosService.put(`${CHARGE_BASE_URL}/updateParty`, payload);
  }

  deleteManifestCharge() {
    return AxiosService.delete(`${CHARGE_BASE_URL}/delete`);
  }

  downloadManifestCharge() {
    return AxiosService.get(`${CHARGE_BASE_URL}/download`);
  }

  getHblCharges(hblId: string) {
    return AxiosService.get<ChargeResponse>(`${CHARGE_BASE_URL}/hbl/get`, {
      params: {
        manifestId: hblId,
      },
    });
  }

  getMblCharges(mblId: string) {
    return AxiosService.get<ChargeResponse>(`${CHARGE_BASE_URL}/mbl/get`, {
      params: {
        manifestId: mblId,
      },
    });
  }

  sendEGuarantee(payload: ChargeServiceEGuaranteePayload) {
    return AxiosService.post(`warehouse/charges/eguarantee`, payload);
  }

  getChargeCodes(cfsId: string) {
    return AxiosService.get<ChargeCode[]>(`${CHARGE_BASE_URL}/codes/${cfsId}`);
  }

  reloadAutoCharges() {
    return AxiosService.get<string>(`${CHARGE_BASE_URL}/reload`);
  }

  // applyDemurrageCharges() {
  //   return AxiosService.post(`${CHARGE_BASE_URL}/hbl/applyDemurrage`);
  // }

  onReloadingCharges(manifestId: string, applyTo: string) {
    return AxiosService.put(`${CHARGE_BASE_URL}/${applyTo.toLowerCase()}/reload/`, {
      manifestId,
    });
  }
}

export default new ChargeService();
